import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  toggleOverlayFlag: true
};

const toggleOverlaySlice = createSlice({
  name: "toggleOverlaySlice",
  initialState,
  reducers: {
    toggle: (state) => {
      state.toggleOverlayFlag = !state.toggleOverlayFlag;
    }
  },
});

export const {toggle} = toggleOverlaySlice.actions;
export default toggleOverlaySlice.reducer;
